import React from 'react';
import { Container, Row, Col } from "react-bootstrap"

export default props => {
	return (
		<section className={"dark"} style={{background: "#1b75bb"}}>
			<Container>
				<Row>
					<Col>
						<h1>{props.data.title}</h1>
					</Col>
				</Row>
			</Container>
		</section>
	)
}